module.exports = __webpack_public_path__ + "statics/img/cate4-3@2x.fb560475.png";